// Navigationsstruktur des Finanzmoduls: EINE Hauptnavigation (Bereiche) + EINE kontextabhaengige Unternavigation (Seiten des gewaehlten Bereichs).
// Alle frueheren Seiten und Funktionen sind hier einer Position zugeordnet (siehe INVENTAR unten) - es entfaellt nichts.
// Sichtbarkeit: "belege" = nur fuer das serverseitig freigegebene Konto (wie bisher der Reiter "Belege"), "pb" = nur wenn die Parallelbuchhaltung serverseitig
// aktiviert ist. Der Server prueft jeden Zugriff erneut; die Navigation blendet nur aus und verhindert, dass abgeschaltete Bereiche ueber alte Links erreichbar sind.

export const BEREICHE = [
  { key: "sepa", label: "SEPA", braucht: "sepa", seiten: [
    { key: "lastschrift", label: "SEPA Lastschrift" },
  ] },
  { key: "uebersicht", label: "Übersicht", seiten: [
    { key: "start", label: "Startseite" },
    { key: "dashboard", label: "Finanzdashboard" },
    { key: "einnahmen-ausgaben", label: "Einnahmen und Ausgaben" },
    { key: "aufgaben", label: "Offene Aufgaben" },
    { key: "fehlende-belege", label: "Fehlende Belege", braucht: "belege" },
    { key: "status", label: "Status der Buchhaltung" },
  ] },
  { key: "bank", label: "Bank & Zahlungen", seiten: [
    { key: "bankumsaetze", label: "Bankumsätze" },
    { key: "import", label: "CSV-Import" },
    { key: "kategorien", label: "Kategorien" },
    { key: "regeln", label: "Regeln" },
    { key: "wiederkehrend", label: "Wiederkehrende Zahlungen" },
    { key: "bankabgleich", label: "Zuordnen", braucht: "belege" },
  ] },
  { key: "belege", label: "Belege", braucht: "belege", seiten: [
    { key: "uebersicht", label: "Belegübersicht" },
    { key: "liste", label: "Alle Belege" },
    { key: "posteingang", label: "Posteingang", stufe: "erweitert" },
    { key: "upload", label: "Foto- und Datei-Upload" },
    { key: "amazon", label: "Amazon-Import", stufe: "erweitert" },
    { key: "erkennung", label: "Rechnungserkennung", stufe: "erweitert" },
    { key: "bankzuordnung", label: "Zuordnen" },
    { key: "kontierung", label: "Kontierung", stufe: "erweitert" },
    { key: "datev", label: "DATEV-Vorbereitung", stufe: "erweitert" },
    { key: "smartphone", label: "Smartphone-Zugänge", stufe: "erweitert" },
  ] },
  { key: "buchhaltung", label: "Buchhaltung (intern)", braucht: "pb", seiten: [
    { key: "pb-start", label: "Parallelbuchhaltung" },
    { key: "pb-einstellungen", label: "Einstellungen und Zuordnungen" },
    { key: "pb-laeufe", label: "Buchungsläufe" },
    { key: "pb-journal", label: "Buchungsjournal" },
    { key: "pb-susa", label: "Summen- und Saldenliste" },
    { key: "pb-bwa", label: "Eigene BWA" },
    { key: "pb-ustva", label: "Umsatzsteuer-Voranmeldung" },
  ] },
  { key: "steuerberater", label: "Steuerberater", seiten: [
    { key: "kanzlei-import", label: "Import Kanzlei-BWA und SuSa" },
    { key: "kontenplan", label: "Kontenplan (SKR03)" },
    { key: "vergleich", label: "Monatsvergleich", braucht: "pb" },
    { key: "abweichungen", label: "Abweichungen", braucht: "pb" },
    { key: "unsichere", label: "Fehlende oder unsichere Buchungen", braucht: "pb" },
    { key: "kontovergleich", label: "Vergleich einzelner Konten", braucht: "pb" },
    { key: "ustva-vergleich", label: "UStVA-Vergleich", braucht: "pb" },
    { key: "befunde", label: "Fachliche Befunde", braucht: "pb" },
  ] },
];

// Sichtbarkeit: "sepa" = Modulrecht SEPA (eigenstaendig), alle uebrigen Bereiche brauchen zusaetzlich das Modulrecht Finanzen ("finanzen").
// Vollstaendiges Inventar der bisherigen Funktionen -> neue Position (dient auch dem Test, dass nichts verloren geht)
export const INVENTAR = [
  ["Reiter Übersicht (KPI, Diagramme, Vergleich, Kategorien, Monatstabelle, wiederkehrende Kosten)", "uebersicht/einnahmen-ausgaben"],
  ["Offene Aufgaben (Finanzübersicht)", "uebersicht/aufgaben (+ Dashboard)"],
  ["Reiter Bankumsätze (Liste, Filter, Bearbeiten, Rücklastschriften, Kontostand)", "bank/bankumsaetze"],
  ["Reiter Import (CSV-Import, Vorschau, Verlauf)", "bank/import"],
  ["Reiter Kategorien", "bank/kategorien"],
  ["Reiter Regeln", "bank/regeln"],
  ["Reiter Wiederkehrend", "bank/wiederkehrend"],
  ["Reiter BWA (Kanzlei-BWA-Import, E-Mail-Abruf, UStVA, Schätzung, Anlagevermögen, Originaldokumente)", "steuerberater/kanzlei-import"],
  ["Reiter Kontenplan (SKR03)", "steuerberater/kontenplan"],
  ["Belege: Übersicht (Weg eines Belegs, Als Nächstes zu tun, Schnellaktionen, Bereitschaft)", "belege/uebersicht"],
  ["Belege: Belegliste und Detailansicht (inkl. Upload per Datei/Foto, Erkennung, Zahlung, Kontierung, DATEV)", "belege/liste"],
  ["Belege: Posteingang (IMAP)", "belege/posteingang"],
  ["Belege: Upload", "belege/upload (+ Schaltflächen in der Belegliste)"],
  ["Belege: Amazon", "belege/amazon"],
  ["Belege: automatische Texterkennung (OCR)", "belege/erkennung (+ Schnellaktion und Belegdetail)"],
  ["Belege: Bankabgleich (Belege <-> Umsätze, Sammel-/Teilzahlungen) – seit Phase 1 EINE gemeinsame Ansicht „Zuordnen“", "belege/bankzuordnung und bank/bankabgleich (beide zeigen dieselbe Ansicht)"],
  ["Neue Startseite (Schnellaktionen, Heute zu erledigen, Finanzübersicht, Zuletzt bearbeitet) – Phase 1", "uebersicht/start (Finanzdashboard bleibt unter uebersicht/dashboard)"],
  ["Belege: Kontierung (SKR03, EXTF)", "belege/kontierung"],
  ["Belege: DATEV (Upload-Mail mit Freigabe, EXTF-Export)", "belege/datev"],
  ["Belege: Fehlende Belege", "uebersicht/fehlende-belege"],
  ["Belege: Smartphone-Zugänge", "belege/smartphone"],
  ["Parallelbuchhaltung: Einstellungen, Zuordnung", "buchhaltung/pb-einstellungen"],
  ["Parallelbuchhaltung: Buchungslauf", "buchhaltung/pb-laeufe"],
  ["Parallelbuchhaltung: Buchungen (Journal)", "buchhaltung/pb-journal"],
  ["Parallelbuchhaltung: Übersicht", "buchhaltung/pb-start"],
  ["Parallelbuchhaltung: SuSa", "buchhaltung/pb-susa"],
  ["Parallelbuchhaltung: BWA", "buchhaltung/pb-bwa"],
  ["Parallelbuchhaltung: Kanzleivergleich (Konten, Salden, BWA, Klassifikation, Notizen)", "steuerberater/vergleich, abweichungen, kontovergleich"],
  ["Parallelbuchhaltung: Umsatzsteuer-Voranmeldung (Kennzahlen, Nachvollziehbarkeit, Warnungen, Druckvorschau, Export, ELSTER-Datei, Zuordnung, Methodenbestätigung)", "buchhaltung/pb-ustva"],
  ["Parallelbuchhaltung: UStVA-Vergleich mit dem Steuerberater (je Kennzahl)", "steuerberater/ustva-vergleich"],
  ["Parallelbuchhaltung: Befunde & Rückrechnung (Bereitschaft)", "steuerberater/befunde"],
  ["SEPA / Mitgliedsbeiträge (frühere Seite der Hauptnavigation, unverändert)", "sepa/lastschrift (erster Bereich in Finanzen)"],
  ["Rechnungen (eigene Seite der Hauptnavigation, unverändert)", "Schnellzugriff im Finanzdashboard"],
];

const ALT_TAB = {   // alte Reiter-Schluessel (z. B. aus "Offene Aufgaben") -> neue Route
  uebersicht: ["uebersicht", "dashboard"], bankumsaetze: ["bank", "bankumsaetze"], import: ["bank", "import"], kategorien: ["bank", "kategorien"], regeln: ["bank", "regeln"],
  wiederkehrend: ["bank", "wiederkehrend"], bwa: ["steuerberater", "kanzlei-import"], kontenplan: ["steuerberater", "kontenplan"], belege: ["belege", "uebersicht"],
};
const ALT_BELEGE = {   // alter Workflow-Schluessel (geheZu der Belegseiten) -> neue Route
  uebersicht: ["belege", "uebersicht"], belege: ["belege", "liste"], posteingang: ["belege", "posteingang"], amazon: ["belege", "amazon"], bank: ["belege", "bankzuordnung"],
  kontierung: ["belege", "kontierung"], datev: ["belege", "datev"], fehlend: ["uebersicht", "fehlende-belege"], smartphone: ["belege", "smartphone"],
};

export const route = (bereich, seite, params) => ({ bereich, seite, params: params || null });
export const routeAusAltemTab = (tab, params) => { const z = ALT_TAB[tab] || ALT_TAB.uebersicht; return route(z[0], z[1], params); };
export const routeAusBelegeKey = (key, params) => { const z = ALT_BELEGE[key] || ALT_BELEGE.uebersicht; return route(z[0], z[1], params); };

const erlaubt = (braucht, ctx) => !braucht || !!ctx[braucht];
const stufeOk = (stufe, ctx) => !stufe || !!ctx.erweitert;   // Seiten der erweiterten Funktionsstufe (Postfach, Amazon, Erkennung, Kontierung, DATEV, Smartphone-Zugaenge)
export function sichtbareBereiche(ctx) {
  return BEREICHE.filter(b => erlaubt(b.braucht, ctx) && (b.key === "sepa" || ctx.finanzen !== false)).map(b => ({ ...b, seiten: b.seiten.filter(s => erlaubt(s.braucht, ctx) && stufeOk(s.stufe, ctx)) })).filter(b => b.seiten.length > 0);
}
// Prueft, ob eine Route im aktuellen Kontext erreichbar ist; sonst Rueckfall auf das Finanzdashboard (deaktivierte Bereiche bleiben unzugaenglich).
export function gueltigeRoute(r, ctx) {
  const b = sichtbareBereiche(ctx).find(x => x.key === r.bereich);
  const s = b?.seiten.find(x => x.key === r.seite);
  if (s) return r;
  const erster = sichtbareBereiche(ctx)[0];   // ohne Finanzen-Recht (nur SEPA) bzw. bei gesperrtem Bereich: erster sichtbarer Bereich
  return erster && erster.key !== "sepa" ? route("uebersicht", "start") : erster ? route(erster.key, erster.seiten[0].key) : route("uebersicht", "start");
}
